// extracted by mini-css-extract-plugin
export default {"mainContainer":"_404_mainContainer__wxYA2","button":"_404_button__m6n0P"};